import CryptoJS from "crypto-js";

const STORAGE_KEY = "cache";
const ENCRYPT_KEY = import.meta.env.VITE_STORAGE_ENCRYPT_KEY;

// Criptografa uma string
export const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    ENCRYPT_KEY
  ).toString();
  return `ENC::${encrypted}`;
};

// Descriptografa uma string
const decrypt = (data) => {
  try {
    const bytes = CryptoJS.AES.decrypt(data, ENCRYPT_KEY);

    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) {
      throw new Error("Decryption failed");
    }

    const parsed = JSON.parse(decrypted);
    return parsed;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Lê o objeto base do cache
export const getCache = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return {};

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.error("Erro ao ler o cache:", error);
    return {};
  }
};

// Salva o objeto inteiro no localStorage
export const setCache = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Erro ao salvar o cache:", error);
  }
};

export const updateCacheItem = (key, value, options = { encrypt: true }) => {
  const cache = getCache() || {};

  if (options.encrypt === false) {
    cache[key] = value;
  } else {
    cache[key] = encrypt(value);
  }

  setCache(cache);
};

// Lê uma chave do cache
export const getCacheItem = (key) => {
  const cache = getCache();
  const item = cache[key];

  if (!item) {
    return null;
  }

  if (typeof item === "string" && item.startsWith("ENC::")) {
    try {
      const encrypted = item.slice(5);
      return decrypt(encrypted);
    } catch (e) {
      console.error(e.message);
      return null;
    }
  }
  return item;
};

// Remove uma chave do cache
export const removeCacheItem = (key) => {
  const cache = getCache();
  delete cache[key];
  setCache(cache);
};

// Limpa tudo
export const clearCache = () => {
  localStorage.clear()
  localStorage.removeItem(STORAGE_KEY);
};
